import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Doughnut } from 'react-chartjs-2'

import type { PositionStatus } from '@Store/types/dashboard'

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels)

function PositionDoughnutChart({
  position,
  showLabels = true,
}: {
  position?: PositionStatus
  showLabels?: boolean
}): JSX.Element {
  const labels = [
    'Highest price',
    'Higher than average',
    'Cheaper than average',
    'Cheapest price',
    'Average price',
    'All equal',
  ]

  const positionArray = Object.values(position ?? {})
  const sum = positionArray.reduce((total, current) => total + current, 0)

  const percentages = {
    highest: (Number((position?.highest ?? 0) / sum) * 100).toFixed(1),
    higher: (Number((position?.higher ?? 0) / sum) * 100).toFixed(1),
    cheaper: (Number((position?.cheaper ?? 0) / sum) * 100).toFixed(1),
    cheapest: (Number((position?.cheapest ?? 0) / sum) * 100).toFixed(1),
    average: (Number((position?.average ?? 0) / sum) * 100).toFixed(1),
    allequal: (Number((position?.allequal ?? 0) / sum) * 100).toFixed(1),
  }

  const data = {
    labels,
    datasets: [
      {
        data: [
          percentages.highest,
          percentages.higher,
          percentages.cheaper,
          percentages.cheapest,
          percentages.average,
          percentages.allequal,
        ],
        backgroundColor: [
          '#F38744',
          '#FAC515',
          '#85E13A',
          '#22CCEE',
          '#A48AFB',
          '#FD6F8E',
        ],
      },
    ],
  }

  return (
    <Doughnut
      data={data}
      options={{
        plugins: {
          legend: {
            display: false,
          },
          datalabels: showLabels
            ? {
                formatter: (value) => {
                  const display = value != 0 ? value + '%' : ''
                  return display
                },
                color: 'white',
                font: {
                  weight: 700,
                  size: 16,
                },
              }
            : {
                display: false,
              },
          tooltip: {
            backgroundColor: 'white',
            titleColor: 'black',
            bodyColor: 'black',
            titleFont: {
              family(ctx, options) {
                return 'Lato'
              },
            },
            displayColors: false,
          },
        },
      }}
    />
  )
}

export default PositionDoughnutChart
